import React, { useEffect, useRef } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import {
  createProcess,
  getAllProcess,
  getProcessById,
  updateProcess,
} from "./services/process.services";
import { clearProcessDetails } from "./processSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Typography } from "@progress/kendo-react-common";

const CreateProcess = () => {
  const formLoading = useAppSelector((state) => state.Process.formLoading);
  const ProcessDetail = useAppSelector((state) => state.Process.ProcessDetail);
  const processGUID = useAppSelector((state) => state.muidrawer.data);
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  useEffect(() => {
    return () => {
      dispatch(clearProcessDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (processGUID) {
      dispatch(getProcessById(processGUID));
    }
  }, [processGUID]);
  const handleSubmit = async (values: any) => {
    try {
      if (!processGUID) {
        const payload = {
          process_name: values?.process_name,
          process_sr_number: values?.process_sr_number,
          isactive: values?.isactive === 1,
        };
        const response = await dispatch(createProcess(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearProcessDetails());
          dispatch(getAllProcess());
        }
      } else {
        const payload = {
          process_guid: processGUID,
          process_name: values?.process_name,
          process_sr_number: values?.process_sr_number,
          isactive: values?.isactive === 1,
        };
        const response = await dispatch(updateProcess(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearProcessDetails());
          dispatch(getAllProcess());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={ProcessDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem>
              <Typography.h4 className="m-0">
                {processGUID ? "Update Process" : "Add Process"}
              </Typography.h4>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="process_name"
                label="Process"
                placeholder="i.e. Bandhai"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="process_sr_number"
                label="Process Serial No"
                placeholder="i.e. 1"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"IsActive"}
                name={"isactive"}
                label={"Status"}
                component={FormSelectionField}
                validator={requiredValidator}
                astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "end",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={processGUID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateProcess;
